//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'express',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      order:{
        factory:[],
        community:{},
        address:{},
        store:{},
      },
      submitStatus:false,
    }
  },
  created(){
    this.config();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr;
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('订单号无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getExpressOrder({order_no:this.code}).then((res)=>{
        if(res){
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        } 
      })  
    },
    submitOrder(){
      let that = this;
      if(!this.order.order_no){
        that.$func.showToast('订单号无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitExpress({order_no:this.order.order_no}).then((res)=>{
        if(res){
          that.submitStatus = false;
          that.$func.showToast('下单成功');
          that.code = '';
          that.order = {
            factory:[],
            community:{},
            address:{},
            store:{},
          };
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/express.vue